export default class arrayHelper
{
	static Equals(first, second)
	{
		if(first===second) return true;
		if(!arrayHelper.BothIsArray(first,second)) return false;
		if(first.length!==second.length) return false;
		for(let i=0;i<first.length;i++)
		{
			if(arrayHelper.BothIsArray(first[i],second[i]))
			{
				if(!this.Equals(first[i],second[i])) return false;
			}
			else
			{
				if(first[i]!==second[i]) return false;
			}
		}
		return true;
	}

	static BothIsArray(first, second)
	{
		return !Array.isArray(first) && Array.isArray(second) ;
	}
	
}
